import React, { useEffect } from "react";
import Buttom from "../../components/Buttom";
import Title from "../../components/Title";
import LayoutDefault from "../Shared/LayoutDefault";

import config from "./../../utils/const";
import "./style.scss";

const EducacaoPerfil = props => {
  useEffect(() => {
    props.actions.setProgressConfig(true, "20%", "1/5");
    props.actions.setProgressBarVisiblity(true);
  }, [props.actions]);

  const HandleAction = val => {
    props.actions.setDonate("profile", val);
  };

  return (
    <LayoutDefault
      className="wrapper-perfil"
      renderButtom={props => (
        <div className="wrapper-buttons">
          <Buttom
            to={`${config.url}educacao/tipo-doacao`}
            text="Pessoa Física"
            onClick={() => {
              HandleAction("pf");
            }}
            {...props}
          />
          <Buttom
            to={`${config.url}educacao/tipo-doacao`}
            text="Pessoa Jurídica"
            onClick={() => {
              HandleAction("pj");
            }}
            {...props}
          />
        </div>
      )}
    >
      <img src={`${config.pathImages}logo-por-mais-um.png`} alt="POR+UM" />
      <p>
        O Por+um, nosso programa de bolsa de estudos, possibilita que jovens de baixa renda estudem Pedagogia, Matemática ou Letras no Singularidades, uma faculdade especializada na formação de professores que se diferencia pelas metodologias inovadoras, orientada para as práticas da sala de aula e
        para os desafios contemporâneos da Educação.&nbsp;
        <a href="http://www.narsp.com.br/" target="_blank" rel="noopener noreferrer">
          Saiba mais
        </a>
      </p>
      <Title className="title">Selecione seu perfil de apoiador:</Title>
    </LayoutDefault>
  );
};

export default EducacaoPerfil;
